import wrapRoutes from "./routesWrapper";

const paths = [
  // Guest
  { name: "login", path: "/", exact: true },
  { name: "newUser", path: "/signup" },
  { name: "existingUser", path: "/signup-existing" },
  { name: "newPassword", path: "/new-password", isGlobal: true },
  { name: "expired", path: "/expired", isGlobal: true },
  { name: "otpCode", path: "/otp" },
  { name: "otpVerify", path: "/otp-verification" },
  { name: "deviceVerify", path: "/device-verification" },
  { name: "otpDeviceVerify", path: "/device-verification-otp" },
  { name: "resetPassword", path: "/reset-password" },

  // Landing Page and other /business/* pages
  { name: "landing", path: "/business", exact: true, isGlobal: true },
  { name: "contactSales", path: "/business/contact-sales", isGlobal: true },

  // Verification from Email
  { name: "verificationFromEmail", path: "/user-verification", isGlobal: true },

  // Profile Email
  { name: "verifyProfileEmail", path: "/email-verification", isGlobal: true },

  // Page Not Found
  { name: "notFound", path: "/404", isGlobal: true },

  // Maintenance
  { name: "maintenance", path: "/maintenance", isGlobal: true },

  // Version
  { name: "feVersion", path: "/fe-version", isGlobal: true },

  // Style Guide
  { name: "styleGuide", path: "/style-guides-flip-v2", isGlobal: true }
];

export default wrapRoutes(paths);
